import { render, staticRenderFns } from "./ProtocoloModalCancelar.vue?vue&type=template&id=5301276c&scoped=true"
import script from "./ProtocoloModalCancelar.vue?vue&type=script&lang=js"
export * from "./ProtocoloModalCancelar.vue?vue&type=script&lang=js"
import style0 from "./ProtocoloModalCancelar.vue?vue&type=style&index=0&id=5301276c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5301276c",
  null
  
)

export default component.exports